<script setup>
const gsapTimeline = useGsapTimeline()
// Steps to reproduce animation:
// 1. Export the animation as a PNG sequence from After Effects
// 2. Use https://www.toptal.com/developers/css/sprite-generator to create a left-to-right sprite from the PNG sequence.
// 3. Use the animated PNG as a mask.

const maskElementB = ref(null)

const frames = 16

const start = async () =>
  await gsapTimeline({ name: 'Mask' })
    .set(maskElementB, { className: maskElementB.value.className + ' mask-ef-to-trans-top-right' })
    .to(maskElementB, { maskPosition: '100% 0', duration: frames / 25, ease: `steps(${frames - 1})` })

defineExpose({ start })
</script>

<template>
  <div ref="maskElementB" class="w-full h-full">
    <slot />
  </div>
</template>

<style>
.mask-ef-to-trans-top-right {
  mask: url('~/assets/animations/energetic_frequencies/to_trans_top_right.png');
}
</style>
